module.exports = __webpack_public_path__ + "img/mainPage-active.55422e25.svg";